<template>
<div class="apCodeUpload-page-content ">
    <div class="main-block position-relative winner-page__hero">
        <div class="position-relative">
            <div class="container-xl">
                <div class="row">
                     <!-- IMG - desktop     -->
                    <div class="col-12 col-lg-7 align-self-center">
                        <div class="winnerType-bgr">
                            <img v-if="winnerType == 'weekly'" :src="`${baseUrl}/lang_images/winnings/heti_1x_${$store.state.currentLang}.png`" class="img-fluid d-none d-lg-block" alt="airwaves"/>
                            <img v-if="winnerType == 'main'" :src="`${baseUrl}/lang_images/winnings/fodij_1x_${$store.state.currentLang}.png`" class="img-fluid d-none d-lg-block" alt="airwaves"/>
                         </div>
                    </div> 
                    <div class="col-12 col-lg-5 d-flex p-0 px-md-4 justify-content-center flex-column align-items-lg-start align-items-center">
                        <h1 class="mb-3 d-none d-lg-block">
                            <!-- <img class="img-fluid" style="border-radius:8px;" :src="`${baseUrl}/lang_images/winner_${$store.state.currentLang}.png`" alt="winner" width="320"/> -->
                            {{tr('winner-congrat')}}
                        </h1>
                        <p class="main-block__hero--p text-center text-lg-left d-none d-lg-block" style="font-size:15px;">{{tr('winner-ervenyes-palyazat-eseten')}}</p>
                        <p class="main-block__hero--p  text-center text-lg-left d-none d-lg-block" v-if="winnerType == 'main'">{{ tr('winner-hero-sub-h1-main') }}</p>
                        <p class="main-block__hero--p  text-center text-lg-left d-none d-lg-block" v-if="winnerType == 'weekly'">{{ tr('winner-hero-sub-h1-weekly') }}</p>

                        <img v-if="winnerType == 'weekly'" :src="`${baseUrl}/lang_images/winnings/heti-mobile_${$store.state.currentLang}.jpg`" class="img-fluid d-block d-lg-none" alt="airwaves" style="margin-top: -1px;"/>
                        <img v-if="winnerType == 'main'" :src="`${baseUrl}/lang_images/winnings/fodij-mobile_${$store.state.currentLang}.jpg`" class="img-fluid d-block d-lg-none" alt="airwaves" style="margin-top: -2px;"/>
                        
                        <button v-if="needBtn" class="btn btn-primary mt-lg-4 mb-lg-5 my-3" v-scroll-to="{ el: '#winnerForm', offset: -80 }">{{tr('kerem-a-nyeremenyem')}}</button>

                    </div>  
                
                </div>
            </div>
        </div>
          
   </div>
   <div class="p-3 bg-primary">
        <p class="real-info-txt py-3 text-center mx-auto text-white mb-0">{{tr('winner-hero-info')}}</p>
    </div>
</div>
</template>

<script>
export default {
    props:['winnerType', 'needBtn']
}
</script>